cv.getPlanMeta = function(plans, plan, plan_type){
  var response_plan = '';
  var response_label = '';

  _.each(plans, function(item, index, list){
    if(!_.isUndefined(item[plan_type]) && index == plan){
      if(!_.isUndefined(item[plan_type]['id'])){
        response_plan = item[plan_type]['id'];
        response_label = item[plan_type]['label'];
      }else{
        response_plan = item[plan_type][0]['id'];
        response_label = item[plan_type][0]['label'];
      }
    }
  }, this);

  return {
    plan_id : response_plan,
    label : response_label
  };
};